import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

interface PageLayoutProps {
  children: ReactNode;
  className?: string;
}

export function PageLayout({ children, className }: PageLayoutProps) {
  return <div className={cn('flex min-h-full w-full flex-col gap-6', className)}>{children}</div>;
}

export function PageContent({ children, className }: PageLayoutProps) {
  return <div className={cn('flex w-full flex-col gap-6', className)}>{children}</div>;
}
